import { configureStore } from "@reduxjs/toolkit";
import loaderReducer from "../reducers/LoaderReducers";
import modalReducer from "../reducers/ModalReducers";
import idReducer from "../reducers/IdReducers";
import changeReducer from "../reducers/ChangeReducer";
import dataReducer from "../reducers/DataReducer";

const store = configureStore({
  reducer: {
    loader: loaderReducer,
    modal: modalReducer,
    id: idReducer,
    status: changeReducer,
    data: dataReducer,
  },
});

export default store;
